import type { ResolvedAttachment } from '@/lib/plugin-registry';

/**
 * Whether the summary renders its own value-specific leading icon, meaning the
 * chip should drop the attachment kind's static icon (e.g. the selected MCP
 * server's integration mark replaces the generic plug).
 *
 * `summaryIncludesIcon` alone is not enough: a plugin can declare it and ship no
 * summary component, and suppressing the kind icon then leaves the chip with no
 * icon at all.
 */
export function summaryOwnsIcon(definition: ResolvedAttachment): boolean {
  return Boolean(definition.summaryComponent && definition.summaryIncludesIcon);
}
